import React from 'react'
import { SiteEditForm } from './site-form'
import SiteSchedules from './schedules/site-schedule'
import ApiKeys from './keys'


const SiteEdit = () => {
  return (
    <div className="site-settings-container">
      <SiteEditForm />
      <SiteSchedules />
      <ApiKeys />
    </div>
  )
}

export default SiteEdit



// WEBPACK FOOTER //
// ./src/components/sites/site-edit.js